module.exports = __webpack_public_path__ + "static/media/logo_ai_modeling1.096ff559.png";